import { useLanguage } from "@/contexts/LanguageContext";

const steps = [
  { key: "orderIn", methodKey: "orderInMethods" },
  { key: "organizes", methodKey: "organizesMethods" },
  { key: "delivers", methodKey: "deliversMethods" },
  { key: "logged", methodKey: "loggedMethods" },
];

export function LinearFlowSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-background py-10 sm:py-12">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-lg sm:text-xl font-bold text-foreground mb-6 tracking-tight">
          {t("landing.flow.headline")}
        </h2>
        
        {/* Vertical flow - brutalist numbered steps */}
        <div className="space-y-0">
          {steps.map((step, index) => (
            <div
              key={step.key}
              className="flex items-stretch"
            >
              {/* Number column */}
              <div className="flex flex-col items-center mr-4">
                <div className="w-8 h-8 rounded-sm bg-foreground text-background flex items-center justify-center text-sm font-mono-display font-bold">
                  {index + 1}
                </div>
                {index < steps.length - 1 && (
                  <div className="w-px flex-1 bg-border min-h-[24px]" />
                )}
              </div>
              
              {/* Content */}
              <div className="pb-6 pt-1">
                <span className="text-sm text-foreground">
                  {t(`landing.flow.${step.key}`)}
                </span>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {t(`landing.flow.${step.methodKey}`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
